import { api } from './api';

export interface CompanySettings {
  currency: string;
  timezone: string;
  dateFormat: string;
  locale?: string;
  symbol?: string;
}

export const companySettingsApi = api.injectEndpoints({
  endpoints: (build) => ({
    getCompanySettings: build.query<{ data: CompanySettings }, void>({
      query: () => '/company-settings',
      providesTags: ['CompanySettings'],
    }),
    updateCompanySettings: build.mutation<
      { data: CompanySettings },
      Partial<Pick<CompanySettings, 'currency' | 'timezone' | 'dateFormat'>>
    >({
      query: (body) => ({ url: '/company-settings', method: 'PATCH', body }),
      invalidatesTags: ['CompanySettings', 'User'],
    }),
  }),
  overrideExisting: false,
});

export const {
  useGetCompanySettingsQuery,
  useUpdateCompanySettingsMutation,
} = companySettingsApi;
